export function DigitalSalesBanner() {
  return (
    <div className="digital-sales-banner">
      <span>A modacad é 100% digital</span>
      <img src="/assets/digital-sales.png" alt="A modacad é 100% digital. Arquivos de moldes para imprimir" />
      <span>Arquivos de moldes para imprimir</span>
    </div>
  );
}
